<template>
  <div class="push-rule-bd tb" v-if="funcView.push_rule_list">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addPushRule" v-if="funcView.push_rule_add">{{ funcView.push_rule_add }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.ruleName" :placeholder="$t('base_messagerule.gui_ze_ming_cheng')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('ruleName')">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('base_messagerule.sxsjks')">
          <custom-date-picker
            v-model="formSearch.effectTimeStart"
            type="datetimerange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width:100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('base_messagerule.sxsjjs')">
          <custom-date-picker
            v-model="formSearch.effectTimeEnd"
            type="datetimerange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width:100%"
          ></custom-date-picker>
        </el-form-item>
        <!-- 推送消息 -->
        <el-form-item :label="$t('base_messagerule.xiao_xi_ming_cheng')" prop="triggerCode">
          <custom-select
            v-model="formSearch.triggerCode"
            url="pushConfRuleSelect"
            :props="{ label: 'triggerCodeName', value: 'triggerCode' }"
            :placeholder="$t('Common.com_please_select')"
            filterable
            remote
            clearable
            reserveKeyword
          ></custom-select>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table tableCode="messagePushRule" v-loading="isLoading" :data="pushRuleList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%" :slots="['ruleName']">
        <template slot="ruleName" slot-scope="scope">
          <span @click="showPushRule(scope.row)" style="color:#00a2df; cursor: pointer" v-if="funcView.pash_rule_view">{{ scope.row.ruleName }}</span>
          <span v-else>{{ scope.row.ruleName }}</span>
        </template>
        <el-table-column :label="$t('Common.com_handle')" min-width="150px" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="editPushRule(scope.row)" v-if="funcView.push_rule_edit">{{ funcView.push_rule_edit }}</el-button>
            <el-button type="text" size="mini" @click="deletePushRule(scope.row)" v-if="funcView.push_rule_delete">{{ funcView.push_rule_delete }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <message-rule-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></message-rule-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import messageRuleDialog from './children/message_rule_dialog';

export default {
  name: 'messagerule',
  mixins: [resetFormSearchMixins],
  components: { messageRuleDialog, },
  data() {
    return {
      formSearch: {
        ruleName: '',
        pageNum: 1,
        pageSize: 50,

        effectTimeStart: [],
        effectTimeEnd: [],

        triggerCode: '',
        dataTimes: ''
      },

      // 参数
      dialogVisible: false,
      dialogModel: {
        data: {
          item: {}
        }
      },
      pushRuleList: [],
      totalRows: 0,
      link: null
    };
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getPushRolePage();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

  },
  methods: {
    // 获取消息规则列表
    getPushRolePage: function () {
      // 是空不传
      this.formSearch.effectTimeStart = this.formSearch.effectTimeStart || undefined;
      this.formSearch.effectTimeEnd = this.formSearch.effectTimeEnd || undefined;

      this.isLoading = true;
      this.$getJSON(apis.PushRulePage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.pushRuleList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    // clearFilter: function () {
    //   this.formSearch.triggerCode = '';
    //   this.formSearch.dataTimes = null; // 生效时间
    //   this.getPushRolePage();
    // },

    // 新增规则
    addPushRule: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_messagerule.xztsgz');
      this.dialogModel.data.isShow = false;
      this.dialogVisible = true;
    },
    // 编辑规则
    editPushRule: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_messagerule.bjtsgz');
      this.dialogModel.data.item = data;
      this.dialogModel.data.isShow = false;
      this.dialogVisible = true;
    },
    // 查看规则
    showPushRule: function (data) {
      this.dialogModel.type = 'show';
      this.dialogModel.title = this.$t('base_messagerule.tsgzxq');
      this.dialogModel.data.item = data;
      this.dialogModel.data.isShow = true;
      this.dialogVisible = true;
    },
    // 删除规则
    deletePushRule: function (data) {
      const tips = this.$t('base_messagerule.nqdyscxzdtsgzm');
      this.$showConfirm(tips)
        .then(() => {
          this.$deleteJSON(`${apis.PushRuleDelete}/${data.ruleId}`).then(() => {
            this.getPushRolePage();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getPushRolePage();
    }
  }
};
</script>
